var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-a-hamburger",class:_vm.classes,attrs:{"aria-label":_vm.ariaLabel,"aria-controls":_vm.ariaControls}},[_c('span',{staticClass:"c-a-hamburger__line"}),_vm._v(" "),_c('span',{staticClass:"c-a-hamburger__line"}),_vm._v(" "),_c('span',{staticClass:"c-a-hamburger__line"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de0e0a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/atoms/AtomHamburger.vue
// module id = 1098
// module chunks = 0